<template>
  <div class="settings-container th-container">
    <div class="settings">
      <div class="heading">Settings</div>
      <TabsList :selected="activeTab" :tabs="tabs" @select="($event) => (activeTab = $event)" :big="true"
                class="settings_tabs"/>
      <template v-if="activeTab === 'Security'">
        <div class="setting-box">
          <div class="setting-text">
            <p>Change Email</p>
          </div>
          <div class="setting-field column">
            <base-input
                :autocomplete="false"
                class="base-input"
                input-type="text"
                input-name="email'"
                placeholder="New email address"
                v-model="settings.email"
            />
            <base-button
                type="button"
                class="primary w-fit-content"
                @click="changeEmail"
            >
              Confirm
            </base-button>
          </div>
        </div>
        <div class="setting-box">
          <div class="setting-text">
            <p>Change Password</p>
          </div>
          <div class="setting-field column">
            <base-input
                :autocomplete="false"
                v-model="settings.password"
                class="base-input"
                input-type="password"
                input-name="password"
                placeholder="New password"
                label-class="mb-12"
            />
            <base-button
                type="button"
                class="primary w-fit-content"
                @click="changePassword"
            >
              Confirm
            </base-button>
          </div>
        </div>
        <div class="x_status_block">
          <p>X Autotweets: <span class="x_status" :class="isAutotweetActive ? 'active': 'inactive'">{{
              isAutotweetActive ? 'Active' : 'Inactive'
            }}</span></p>
          <base-button
              v-if="isXConnected"
              type="button"
              class="primary w-fit-content"
              @click="xModalStatus = true"
          >
            Settings
          </base-button>
          <base-button
              v-else
              type="button"
              class="primary w-fit-content"
              @click="connectX"
          >
            Connect
          </base-button>
        </div>
        <div class="blocked_accounts_block">
          <p>Blocked Accounts</p>
          <p>{{ user.blocked_users.length }}</p>
        </div>
      </template>
      <template v-else-if="activeTab === 'Profile'">
        <div class="setting-box selectable-setting">
          <div class="setting-text">
            <p>Display Rank On Profile</p>
          </div>
          <div class="setting-field">
            <base-button
                type="button"
                class="w-fit-content"
                :class="user.display_rank_on_profile === 1 ? 'primary active' : 'secondary'"
                @click="updateField($event,'display_rank_on_profile',1)"
            >
              On
            </base-button>
            <base-button
                type="button"
                class="w-fit-content"
                :class="user.display_rank_on_profile !== 1 ? 'primary active' : 'secondary'"
                @click="updateField($event,'display_rank_on_profile',0)"
            >
              Off
            </base-button>
          </div>
        </div>
        <div class="setting-box selectable-setting">
          <div class="setting-text">
            <p>Display account on leaderboard</p>
          </div>
          <div class="setting-field">
            <base-button
                type="button"
                class="w-fit-content"
                :class="user.display_account_on_leaderboard === 1 ? 'primary active' : 'secondary'"
                @click="updateField($event,'display_account_on_leaderboard',1)"
            >
              On
            </base-button>
            <base-button
                type="button"
                class="w-fit-content"
                :class="user.display_account_on_leaderboard !== 1 ? 'primary active' : 'secondary'"
                @click="updateField($event,'display_account_on_leaderboard',0)"
            >
              Off
            </base-button>
          </div>
        </div>
        <div class="setting-box selectable-setting has_small_text">
          <div class="setting-text">
            <p>Activity Status</p>
          </div>
          <div class="setting_small_text">Allow users to see if you’re online/offline</div>
          <div class="setting-field">
            <base-button
                type="button"
                class="w-fit-content"
                :class="user.activity_status === 1 ? 'primary active' : 'secondary'"
                @click="updateField($event,'activity_status',1)"
            >
              On
            </base-button>
            <base-button
                type="button"
                class="w-fit-content"
                :class="user.activity_status !== 1 ? 'primary active' : 'secondary'"
                @click="updateField($event,'activity_status',0)"
            >
              Off
            </base-button>
          </div>
        </div>
      </template>
      <template v-else-if="activeTab === 'Account'">
        <div v-if="isCreator && paymentProvider !== 'centryos' && !user.stripe_account_is_verified" class="setting-box stripe_field">
          <div class="setting-field">
            <base-button
                type="button"
                class="w-fit-content primary active"
                @click="connectStripe"
            >Connect Stripe</base-button>
          </div>
        </div>
        <section v-if="isCreator" class="centryos-card">
          <div class="centryos-card__header">
            <div class="centryos-card__logo">C</div>
            <div class="centryos-card__title">
              <h2>CentryOS payouts</h2>
              <p>Receive gifts and withdraw to your bank or card.</p>
            </div>
            <span class="centryos-card__status" :class="{'is-ready': centryStatus?.ready}">
              {{ centryStatus?.ready ? 'Ready' : 'Setup required' }}
            </span>
          </div>

          <div class="centryos-card__balance">
            <span>Available balance</span>
            <strong>${{ centryBalance }}</strong>
          </div>

          <div v-if="centryStatus?.active_payout" class="centryos-card__notice" role="status">
            Payout #{{ centryStatus.active_payout.id }}: {{ payoutStatusLabel(centryStatus.active_payout.status) }}.
            ${{ Number(centryStatus.active_payout.amount).toFixed(2) }} is reserved and excluded from your available balance.
            <button v-if="centryStatus.hosted_payouts_enabled && centryStatus.active_payout.status === 'AWAITING_CONFIRMATION'"
                    type="button" :disabled="centryLoading" @click="resumeHostedPayout">Resume secure payout</button>
            <p v-if="['SUBMITTING', 'REVIEW_REQUIRED'].includes(centryStatus.active_payout.status)">
              We’re confirming this payout. Please don’t submit it again. Contact support if it stays pending.
            </p>
          </div>
          <button v-if="centryStatus" type="button" class="secondary" @click="loadCentryStatus">Refresh payout status</button>
          <div v-if="centryStatus?.payouts?.length" class="centryos-card__notice">
            <h3>Recent payouts</h3>
            <ul>
              <li v-for="payout in centryStatus.payouts" :key="payout.id">
                #{{ payout.id }} — ${{ Number(payout.amount).toFixed(2) }} — {{ payoutStatusLabel(payout.status) }}
              </li>
            </ul>
          </div>

          <div v-if="centryError" class="centryos-card__alert" role="alert">
            <span>{{ centryError }}</span>
            <button type="button" aria-label="Dismiss error" @click="centryError = ''">×</button>
          </div>

          <div v-if="centryStatus && !centryStatus.configured" class="centryos-card__notice">
            CentryOS API credentials must be configured on the server before setup.
          </div>

          <div v-if="!centryStatus" class="centryos-card__loading">Loading payout status…</div>

          <div v-else class="centryos-card__actions">
            <base-button
                v-if="centryStatus.configured && !centryStatus.ready"
                type="button"
                class="primary centryos-card__primary"
                :loading="centryLoading"
                :disabled="centryLoading"
                @click="provisionCentryOs"
            >Set up CentryOS</base-button>

            <template v-if="centryStatus.ready">
              <div class="centryos-card__button-row">
                <base-button type="button" class="primary" :disabled="centryLoading" @click="linkCentryAccount">
                  Link bank or card
                </base-button>
                <base-button type="button" class="secondary" :disabled="centryLoading" @click="loadLinkedAccounts">
                  Refresh accounts
                </base-button>
              </div>

              <p class="centryos-card__notice">
                Linking opens in a new tab. After the green success check, close that tab and return here.
                Your account is saved even if the form clears. Click Refresh accounts to see it.
              </p>
              <div v-if="accountsLoading" class="centryos-card__loading" role="status">Loading saved accounts…</div>
              <div v-if="linkedAccounts.length" class="centryos-card__form">
                <h3>Withdraw to a linked account</h3>
                <label>
                  <span>Payout account</span>
                  <select v-model="withdrawal.linked_account_id">
                    <option disabled value="">Select an account</option>
                    <option v-for="account in linkedAccounts" :key="account.id" :value="account.id">
                      {{ payoutAccountLabel(account) }}
                    </option>
                  </select>
                </label>
                <div class="centryos-card__form-row">
                  <label>
                    <span>Amount (USD)</span>
                    <input v-model.number="withdrawal.amount" type="number" min="10" max="5000" step="0.01" placeholder="0.00">
                  </label>
                  <label v-if="selectedPayoutAccount?.optionType?.toLowerCase() === 'bank'">
                    <span>Transfer speed</span>
                    <select v-model="withdrawal.routing_type">
                      <option value="ACH">ACH</option>
                      <option value="RTP">RTP</option>
                      <option value="WIRE">Wire</option>
                      <option value="BANK">Bank</option>
                    </select>
                  </label>
                </div>
                <base-button type="button" class="primary centryos-card__primary" :loading="centryLoading" :disabled="centryLoading || !!centryStatus.active_payout" @click="withdrawCentryOs">
                  Withdraw funds
                </base-button>
              </div>

              <div v-else-if="!accountsLoading && !centryError" class="centryos-card__empty">
                No payout account linked yet. Link a bank account or card to withdraw funds.
              </div>

              <div v-if="centryStatus.hosted_payouts_enabled" class="centryos-card__form centryos-card__hosted">
                <h3>Hosted payout</h3>
                <label>
                  <span>Amount (USD)</span>
                  <input
                      v-model.number="payoutWidgetAmount"
                      type="number"
                      min="10" max="5000"
                      step="0.01"
                      placeholder="0.00"
                      @input="centryError = ''"
                  >
                </label>
                <base-button type="button" class="secondary centryos-card__primary" :disabled="centryLoading || !!centryStatus.active_payout" @click="openPayoutWidget">
                  Open secure payout
                </base-button>
              </div>
            </template>
          </div>
        </section>
        <div class="setting-box selectable-setting">
          <div class="setting-text">
            <p>Email Notifications</p>
          </div>
          <div class="setting-field">
            <base-button
                type="button"
                class="w-fit-content"
                :class="user.email_notifications === 1 ? 'primary active' : 'secondary'"
                @click="updateField($event,'email_notifications',1)"
            >
              On
            </base-button>
            <base-button
                type="button"
                class="w-fit-content"
                :class="user.email_notifications !== 1 ? 'primary active' : 'secondary'"
                @click="updateField($event,'email_notifications',0)"
            >
              Off
            </base-button>
          </div>
        </div>
        <div class="setting-box selectable-setting">
          <div class="setting-text">
            <p>App Notifications</p>
          </div>
          <div class="setting-field">
            <base-button
                type="button"
                class="w-fit-content"
                :class="user.email_notifications === 1 ? 'primary active' : 'secondary'"
                @click="updateField($event,'email_notifications',1)"
            >
              On
            </base-button>
            <base-button
                type="button"
                class="w-fit-content"
                :class="user.email_notifications !== 1 ? 'primary active' : 'secondary'"
                @click="updateField($event,'email_notifications',0)"
            >
              Off
            </base-button>
          </div>
        </div>
        <div class="setting-box selectable-setting currency-select">
          <div class="setting-text">
            <p>Display currency</p>
          </div>
          <div class="setting-field">
            <base-select
                v-if="currency"
                :options="currencies"
                :visible-key="'code'"
                :selected="currency"
                :search-on="true"
                :text="'Select Currency'"
                class="select"
                @selected="changeCurrency($event)"
            />

          </div>
        </div>
        <div class="setting-box">
          <div class="delete-user">
            <p @click="openDeleteAccountConfirm">Delete account</p>
          </div>
        </div>
      </template>
    </div>
    <confirm-modal
        v-if="confirmDialog"
        @result="deleteAccount"
        @close="confirmDialog = false"
    />

    <XModal v-if="xModalStatus" @close="xModalStatus = false"/>
  </div>
</template>

<script setup>
import BaseInput from "../../UI/BaseInput";
import BaseButton from "../../UI/BaseButton";
import BaseSelect from "../../UI/BaseSelect";
import ConfirmModal from "../../Modals/ConfirmModal";
import TabsList from "@/router/components/tabs/TabsList.vue";
import XModal from "@/router/components/dashboard/XModal.vue";
</script>

<script>
import './SettingsPage.scss';
import {mapActions, mapGetters} from "vuex";
import preloader from "@/mixins/preloader";
import {isFlagOn} from "@/helpers/xOAuth";

export default {
  name: "SettingsPage",
  mixins: [preloader],
  data() {
    return {
      tabs: ['Security', 'Profile', 'Account'],
      activeTab: ['linked', 'payout'].includes(this.$route.query.centryos) ? 'Account' : 'Security',
      settings: {
        email: null,
        password: null,
      },
      currencies: [],
      confirmDialog: false,
      xModalStatus: false,
      centryStatus: null,
      centryLoading: false,
      centryError: '',
      linkedAccounts: [],
      accountsLoading: false,
      linkingAccount: false,
      payoutWidgetAmount: null,
      withdrawal: {
        linked_account_id: '',
        amount: null,
        routing_type: 'ACH',
      },
    }
  },
  computed: {
    ...mapGetters({user: 'auth/user', currency: "currency"}),
    paymentProvider() {
      return process.env.VUE_APP_PAYMENT_PROVIDER || 'centryos'
    },
    isCreator() {
      return Number(this.user.role_id) === 1
    },
    selectedPayoutAccount() {
      return this.linkedAccounts.find(account => account.id === this.withdrawal.linked_account_id)
    },
    centryBalance() {
      return Number(this.centryStatus?.balance || 0).toFixed(2)
    },
    isXConnected() {
      return isFlagOn(this.user?.is_x_connected)
    },
    isAutotweetActive() {
      return this.isXConnected && isFlagOn(this.user?.x_autotweet)
    },
  },
  async mounted() {
    window.addEventListener('focus', this.refreshAfterLinking);
    this.getCurrencies();
    if (this.isCreator) {
      this.loadCentryStatus();
    }
    await this.finishXConnect();
  },
  beforeUnmount() {
    window.removeEventListener('focus', this.refreshAfterLinking)
  },
  methods: {
    ...mapActions({
      logoutStore: 'auth/logout',
      signIn: 'auth/login',
      getCurrency: "getCurrency"
    }),
    async connectX() {
      this.setLoading(true)
      try {
        const { data } = await this.axios.post('oauth/x/connect', { frontend: window.location.origin })
        window.location.assign(data.authorization_url)
      } catch (error) {
        this.setLoading(false)
        this.toast.error(error.response?.data?.message || 'Unable to start X authorization')
      }
    },
    async finishXConnect() {
      const query = { ...this.$route.query }
      const socialError = query.social_error
      if (socialError) {
        this.toast.error(socialError)
      }

      const xConnected = query.x_connected === '1'

      const stripXQuery = () => {
        delete query.x_connected
        delete query.social_error
        this.$router.replace({ query })
      }

      if (xConnected) {
        try {
          await this.signIn({ force: true })
          this.toast.info('X Autotweets are now active')
        } catch (error) {
          this.toast.error(error.response?.data?.message || error.message || 'Unable to connect X account')
        } finally {
          this.setLoading(false)
          stripXQuery()
        }
        return
      }

      this.setLoading(false)
      if (socialError || query.x_connected) {
        stripXQuery()
      }
    },
    getCurrencies() {
      this.axios.post('currencies/get')
          .then((res) => {
            this.currencies = res.data.currencies;
          })
    },
    changeEmail() {
      this.axios.post('user/change-email',
          {
            email: this.settings.email
          }
      ).then((res) => {
        this.settings.email = null
        this.toast.info(res.data.message);
      }).catch((res) => {
        this.toast.error(res.response.data.message);
      })
    },
    changePassword() {
      this.axios.post('user/change-password',
          {
            password: this.settings.password
          }
      ).then((res) => {
        this.settings.password = null
        this.toast.info(res.data.message);
      }).catch((res) => {
        this.toast.error(res.response.data.message);
      })
    },
    openDeleteAccountConfirm() {
      this.confirmDialog = true;
    },
    deleteAccount(event) {
      if (event === true) {
        this.axios.post('user/delete-account').then((res) => {
          this.logoutStore();
          localStorage.removeItem('access_token');
          if (this.$route.name !== 'home') {
            this.$router.push({name: 'home'})
          }
          this.toast.info(res.data.message);
        }).catch((res) => {
          this.toast.error(res.response.data.message);
        })
      }
    },
    updateField(event, field, value) {
      let activeButton = event.target.parentElement.querySelector('button.active');
      if (activeButton !== event.target) {
        activeButton.classList.remove('primary');
        activeButton.classList.remove('active');
        activeButton.classList.add('secondary');
        event.target.classList.add('active');
        event.target.classList.remove('secondary');
        event.target.classList.add('primary');
      }
      this.axios.post('user/update-field',
          {
            field: field,
            field_value: value
          }).then((res) => {
        this.toast.info(res.data.message);
      }).catch((res) => {
        this.toast.error(res.response.data.message);
      })
    },
    changeCurrency(event) {
      this.axios.post('user/update-selected-currency', {
        selected_currency_id: event.id
      }).then((res) => {
        this.signIn();
        this.getCurrency();
        this.toast.info(res.data.message);
      }).catch((res) => {
        this.toast.error(res.response.data.message);
      });
    },
    connectStripe() {
      this.setLoading(true)
      this.axios.post('/connect-stripe').then((response) => {
        if(response.data.success) {
          window.location.href = response.data.link
        } else {
          this.setLoading(false)
          this.toast.error(response.data.message)
        }
      }).catch((res) => {
        this.setLoading(false)
        this.toast.error(res.response.data.message);
      })
    },
    loadCentryStatus() {
      return this.axios.get('centryos/status').then((res) => {
        this.centryStatus = res.data
        const saved = this.savedPayoutRequest()
        if (saved && res.data.payouts?.some(payout => payout.idempotency_key === saved.key && ['SUCCESS', 'FAILED', 'REJECTED'].includes(payout.status))) {
          localStorage.removeItem(this.payoutStorageKey())
        }
        if (res.data.ready) this.loadLinkedAccounts()
      }).catch((res) => this.showCentryError(res, 'Unable to load CentryOS status'))
    },
    provisionCentryOs() {
      this.centryLoading = true
      this.centryError = ''
      this.axios.post('centryos/provision').then(() => {
        this.toast.info('CentryOS account is ready')
        this.loadCentryStatus()
      }).catch((res) => this.showCentryError(res, 'CentryOS setup failed'))
          .finally(() => { this.centryLoading = false })
    },
    refreshAfterLinking() {
      if (this.linkingAccount && !this.centryLoading) this.loadLinkedAccounts()
    },
    payoutAccountLabel(account) {
      const name = account.nickName || account.counterPartyName || account.name || account.accountName || 'Account'
      const type = account.optionType || account.type || ''
      const masked = account.account?.last4 || account.recipientData?.last4 || account.mask || account.last4 || account.recipientData?.accountNumber || ''
      return [name, type, masked].filter(Boolean).join(' · ')
    },
    linkCentryAccount() {
      const widget = window.open('about:blank', '_blank')
      if (widget) widget.opener = null
      this.centryLoading = true
      this.centryError = ''
      return this.axios.post('centryos/linked-account-widget').then((res) => {
        const url = res?.data?.url
        if (typeof url !== 'string' || !url.startsWith('https://')) {
          throw new Error('CentryOS did not return a valid account-linking URL')
        }
        this.linkingAccount = true
        if (widget && !widget.closed) widget.location.replace(url)
        else window.location.assign(url)
      }).catch((res) => {
        if (widget && !widget.closed) widget.close()
        this.showCentryError(res, 'Unable to open account linking')
      }).finally(() => { this.centryLoading = false })
    },
    loadLinkedAccounts() {
      if (this.accountsLoading) return
      this.accountsLoading = true
      this.centryError = ''
      return this.axios.get('centryos/linked-accounts').then((res) => {
        this.linkedAccounts = res.data.accounts || []
        if (!this.linkedAccounts.some(account => account.id === this.withdrawal.linked_account_id)) {
          this.withdrawal.linked_account_id = this.linkedAccounts[0]?.id || ''
        }
      }).catch((res) => this.showCentryError(res, 'Unable to load payout accounts'))
        .finally(() => { this.accountsLoading = false })
    },
    async resumeHostedPayout() {
      const payout = this.centryStatus?.active_payout
      if (!payout || this.centryLoading) return
      this.centryLoading = true
      try {
        const res = await this.axios.post('centryos/payout-widget', {amount: Number(payout.amount), idempotency_key: payout.idempotency_key})
        if (res.data.url?.startsWith('https://')) window.location.assign(res.data.url)
        else this.showCentryError(null, 'This payout link is no longer available. Contact support to confirm the payout status.')
      } catch (error) {
        this.showCentryError(error, 'Unable to reopen payout')
      } finally {
        this.centryLoading = false
      }
    },
    payoutStatusLabel(status) {
      return ({SUBMITTING: 'Submitting', REVIEW_REQUIRED: 'Awaiting confirmation', AWAITING_CONFIRMATION: 'Awaiting hosted confirmation',
        PENDING: 'Pending', PROCESSING_PAY_OUT: 'Processing', SUCCESS: 'Paid', FAILED: 'Failed — funds returned', REJECTED: 'Not sent — funds returned'})[status] || status
    },
    payoutStorageKey() {
      return 'centryos-payout:' + this.user.id
    },
    savedPayoutRequest() {
      try { return JSON.parse(localStorage.getItem(this.payoutStorageKey()) || 'null') }
      catch (_) { return null }
    },
    payoutRequestKey(payload) {
      const saved = this.savedPayoutRequest()
      const fingerprint = JSON.stringify(payload)
      if (saved) {
        if (saved.fingerprint !== fingerprint) throw new Error('Check the status of your previous payout before changing its details.')
        return saved.key
      }
      const key = window.crypto.randomUUID()
      localStorage.setItem(this.payoutStorageKey(), JSON.stringify({key, fingerprint}))
      return key
    },
    openPayoutWidget() {
      return this.sendPayout('hosted', Number(this.payoutWidgetAmount))
    },
    withdrawCentryOs() {
      if (!this.withdrawal.linked_account_id) return this.showCentryError(null, 'Select a payout account')
      return this.sendPayout('direct', Number(this.withdrawal.amount))
    },
    async sendPayout(kind, amount) {
      if (this.centryLoading || this.centryStatus?.active_payout) return
      if (!Number.isFinite(amount) || amount < 10 || amount > 5000 || Math.abs(amount * 100 - Math.round(amount * 100)) > 0.00001) {
        return this.showCentryError(null, 'Enter a payout amount between $10 and $5,000 with no more than two decimal places')
      }
      if (amount > Number(this.centryStatus?.balance || 0)) return this.showCentryError(null, 'Payout amount exceeds your available balance')
      this.centryLoading = true
      this.centryError = ''
      let sent = false
      try {
        const payload = kind === 'hosted' ? {amount} : {
          amount, linked_account_id: this.withdrawal.linked_account_id,
          routing_type: this.selectedPayoutAccount?.optionType?.toLowerCase() === 'bank' ? this.withdrawal.routing_type : null,
        }
        const key = this.payoutRequestKey({kind, ...payload})
        sent = true
        const res = await this.axios.post(kind === 'hosted' ? 'centryos/payout-widget' : 'centryos/withdraw', {...payload, idempotency_key: key})
        if (kind === 'hosted' && res.data.url) {
          if (!res.data.url.startsWith('https://')) throw new Error('Invalid payout URL')
          window.location.assign(res.data.url)
        } else {
          this.toast.info(this.payoutStatusLabel(res.data.payout.status))
          this.withdrawal.amount = null
        }
      } catch (error) {
        if (sent && error.response?.status === 422) localStorage.removeItem(this.payoutStorageKey())
        this.showCentryError(error, 'Unable to confirm the payout. Refresh payout status before trying again.')
      } finally {
        await this.loadCentryStatus()
        this.centryLoading = false
      }
    },
    showCentryError(error, fallback) {
      const responseMessage = error?.response?.data?.message
      const browserMessage = typeof error?.message === 'string' ? error.message : ''
      const traceId = error?.response?.headers?.['x-payout-trace-id']
      const message = responseMessage || browserMessage || fallback
      this.centryError = traceId ? `${message} (Reference: ${traceId})` : message
      console.error('CentryOS request failed', {
        status: error?.response?.status || null,
        traceId: traceId || null,
      })
      this.toast.error(this.centryError)
    },
  }
}
</script>
